module.exports = __webpack_public_path__ + "img/rotate-left.e8f51c1d.svg";